import {useFormik} from 'formik'
import {
  createDemandeDemontage,
  getAllPieceTypePiecesOptions,
  getSearchPieceTypePiece,
} from '../../../../components/requests'
import React, {useEffect, useRef, useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {SelectInput} from '../../../../components/inputs/SelectInput'
import {prioriteDemandeDemontage} from '../../../../components/Data'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import {KTIcon} from '../../../../_metronic/helpers'
import {toast} from 'react-toastify'
import {SearchPiece} from '../../../../components/SearchPiece'

const DemandDemontageForm = (props) => {
  const {
    showModalProp,
    vehiculeId,
    numeroVehicule,
    setData,
    typePiece,
    isRedirection,
    demandeId,
    typePieceHn,
    pieceInstance
  } = props
  const {currentUser} = useAuth()

  const initialValues: any = {
    typePieces: '',
    vehiculeId: vehiculeId,
    demandeParId: currentUser?.id,
    commentaire: '',
    priorite: 'Normale',
    demandeId: demandeId,
  }

  const [valueTypePieces, setValueTypePieces] = useState<any>(
    typePiece && isRedirection ? [typePiece] : []
  )
  const [loadingModal, setLoadingModal] = useState(true)
  const [loading, setLoading] = useState(false)
  const [match, setMatch] = useState<Array<string> | null>([])
  const [suggestion, setSuggestion] = useState<Array<string>>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [clearInput, setClearInput] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [pieceTypePiece, setPieceTypePiece] = useState<string>('')
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)

  // Récupération des options sur le type pièces
  const getTypePiecesData = () => {
    setLoadingModal(true)
    getAllPieceTypePiecesOptions()
      .then((typePiecesRequest) => {
        if (typePiecesRequest?.status === 200 && typePiecesRequest?.data) {
          setSuggestion(typePiecesRequest.data.map((item) => item.label))
        }
      })
      .catch((e) => {
        console.error('Erreur chargement suggestions:', e)
      })
      .finally(() => {
        setLoadingModal(false)
      })
  }

  useEffect(() => {
    if (typePieceHn) {
      const typePieceHorsNom = {
        id: null,
        nom: typePieceHn,
        code: '999999',
        isHorNom: true,
      }
      setValueTypePieces((prevTypePiece) => [...prevTypePiece, typePieceHorsNom])
      formik.setFieldValue('typePieceHn', typePieceHn)
    }
  }, [])

  useEffect(() => {
    getTypePiecesData()
    if (typePiece && isRedirection) {
      const typePiecesSpec = valueTypePieces
        ? valueTypePieces.map((typePiece) => typePiece.id).join(',')
        : ''
      formik.setFieldValue('typePieces', typePiecesSpec)
    }
  }, [])

  const onSubmitHandler = (values, formikHelpers) => {
    const typePieces = valueTypePieces
      .map((typePiece) => typePiece.id)
      .filter((value, index, self) => value !== null && self.indexOf(value) === index)
      .join(',')

    const payload = {
      ...values,
      typePieces: typePieces,
      demandeId: demandeId,
      pieceInstance: pieceInstance
    }

    setLoading(true)
    createDemandeDemontage(payload)
      .then((demandeDemontageRequest) => {
        if (demandeDemontageRequest?.status === 200) {
          if (demandeDemontageRequest?.data !== undefined) {
            const numeroVehic = demandeDemontageRequest?.data?.vehicule?.numero
            const idDemandeDemontage = demandeDemontageRequest?.data?.id
            setData((prevI) =>
              prevI.map((i) =>
                i[0].numero === numeroVehic ? {...i, demandeDemontageId: idDemandeDemontage} : i
              )
            )
            setValueTypePieces([])
            formikHelpers.resetForm()
            setLoading(false)
            showModalProp(false)
            toast.success(
              `Votre demande de démontage du véhicule n° ${numeroVehicule} a été effectuée avec succès.`
            )
          } else {
            setLoading(false)
          }
        } else {
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const formik = useFormik<any>({
    initialValues: initialValues,
    onSubmit: (values, formikHelpers) => onSubmitHandler(values, formikHelpers),
    validateOnBlur: true,
    validateOnChange: false,
  })

  // gestion recherche de pièce par type pièce
  const searchPieceTypePiece = (inputValue) => {
    setSearchValue(inputValue)
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    // Traitement du nom tappé dans le formulaire et enregistrement de la suggestion
    if (inputValue !== '' && inputValue !== null) {
      const matchingValue = String(
        suggestion.find((name) => name.toLowerCase().startsWith(inputValue.toLowerCase()))
      ).toLowerCase()
      if (matchingValue !== 'undefined' && matchingValue !== null) {
        const prefix = inputValue
        const suffix = matchingValue.slice(inputValue.length)
        setMatch([prefix, suffix])
      } else {
        setMatch([])
      }
    } else {
      setMatch([])
    }

    searchTypePiece(inputValue)
  }

  function searchTypePiece(value) {
    timeoutRef.current = setTimeout(() => {
      if (value !== '') {
        setPieceSpinner(true)
        getSearchPieceTypePiece(value)
          .then((res) => {
            if (res?.status === 200 && res?.data) {
              setResultShowPiece(true)
              setPieceTypePiece(res.data)
            } else {
              setResultShowPiece(false)
              setPieceTypePiece('')
            }
          })
          .catch(() => {
            console.log('error')
          })
          .finally(() => {
            setPieceSpinner(false)
          })
      }
    }, 800)
  }

  // Autocompletion de la suggestion en appuyant sur Tab ou sur Entrer
  const autocompleteOnKeyDown = (e) => {
    if (
      (e.code === 'Tab' || e.code === 'Enter' || e.code === 'ArrowRight') &&
      match &&
      match.length !== 0
    ) {
      e.preventDefault()
      e.target.value = match.join('').toLowerCase()
      searchPieceTypePiece(e.target.value)
      setMatch([])
    }
  }

  const handleRemovetypePiece = (idToRemove: number) => {
    const updated = valueTypePieces.filter((p) => p.id !== idToRemove)
    setValueTypePieces(updated)
    if (idToRemove === null) formik.setFieldValue('typePieceHn', '')
    formik.setFieldValue('typePieces', updated.map((p) => p.id).join(','))
  }

  return (
    <div>
      <form action='#' onSubmit={formik.handleSubmit}>
        {loadingModal ? (
          <div className='d-flex flex-column flex-center h-100 p-6'>
            <KTIcon iconName='loading' className='fs-3x text-primary mb-2' />
          </div>
        ) : (
          <div className='App'>
            <div className='modal-body pt-3'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Pièces</label>
                  <SearchPiece
                    inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                    placeholder={'Recherche type pièce'}
                    onChange={(e) => searchPieceTypePiece(e.target.value)}
                    onKeyDown={(e) => autocompleteOnKeyDown(e)}
                    resultatPiece={pieceTypePiece}
                    value={searchValue}
                    match={match}
                    setMatch={setMatch}
                    setSearchValue={setSearchValue}
                    pieceSpinner={pieceSpinner}
                    resultShowPiece={resultShowPiece}
                    clearInput={clearInput}
                    selectedSearchValue=''
                    showPieceHn={false}
                    onSelect={(selectedPiece) => {

                      if (demandeId && valueTypePieces.length >= 1) { // pour le moment limiter la séléction en une seule pièce
                        setClearInput(true)
                        setSearchValue('')
                        setMatch([]) // Nettoyage du champ d'autocompletion après la selection
                        toast.error('Vous ne pouvez sélectionner qu’une seule pièce', {
                          autoClose: 4000,
                        })
                        return
                      }
                      if (!valueTypePieces.some((p) => p.id === selectedPiece.id)) {
                        const updated = [...valueTypePieces, selectedPiece]
                        setValueTypePieces(updated)
                        const typePieces = updated
                          .filter((p) => p.id !== null && p.id !== '')
                          .map((p) => p.id)
                          .join(',')
                        formik.setFieldValue('typePieces', typePieces)
                      } else {
                        toast.error('Pièce déjà ajoutée dans la liste', {autoClose: 4000})
                      }
                      setClearInput(true)
                      setSearchValue('')
                      setMatch([]) // Nettoyage du champ d'autocompletion après la selection
                    }}
                  />
                  {valueTypePieces.length > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                        minHeight: '48px',
                        maxHeight: '120px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        padding: '6px 8px',
                        backgroundColor: '#f9f9f9',
                        cursor: 'text',
                        marginTop: '12px',
                      }}
                    >
                      {valueTypePieces.map((valueTypePiece) => (
                        <div
                          key={valueTypePiece.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#e7f3ff',
                            color: '#0d6efd',
                            borderRadius: '16px',
                            padding: '4px 10px',
                            margin: '4px',
                            fontSize: '14px',
                          }}
                        >
                          {valueTypePiece?.isHorNom && valueTypePiece?.id === null && '[99999]'}{' '}
                          {valueTypePiece.nom}
                          <button
                            type='button'
                            onClick={() => handleRemovetypePiece(valueTypePiece.id)}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#0d6efd',
                              fontWeight: 'bold',
                              marginLeft: '8px',
                              cursor: 'pointer',
                              fontSize: '16px',
                              lineHeight: '1',
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                      <input
                        type='text'
                        value=''
                        disabled
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          minWidth: '120px',
                          fontSize: '14px',
                          margin: '4px',
                          backgroundColor: 'transparent',
                          color: '#999',
                          cursor: 'not-allowed',
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='col-lg-6 col-form-label required fw-bold fs-6'>Priorité</label>
                  <SelectInput
                    fieldName={'priorite'}
                    inputClassName={'form-select form-select-lg fw-bold'}
                    options={prioriteDemandeDemontage}
                    formik={formik}
                  />
                </div>
                <div className='col-sm-6'></div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Commentaire</label>
                  <TextInput
                    fieldName={'commentaire'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <div className='row'>
                <div className='col-sm-12' style={{textAlign: 'right'}}>
                  <Button variant='secondary me-5' onClick={() => showModalProp(false)}>
                    Annuler
                  </Button>
                  <Button variant='info' type='submit' disabled={valueTypePieces.length === 0}>
                    {!loading && 'Enregistrer'}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Enregistrement...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  )
}

export {DemandDemontageForm}
